import css from './AuthErrorMessage.module.scss';

interface AuthErrorMessageProps {
  message: string;
  type?: 'error' | 'warning';
  className?: string;
}

export const AuthErrorMessage = ({ message, type = 'error', className }: AuthErrorMessageProps) => {
  return (
    <span
      className={`${css.errorMessage} ${type === 'warning' ? css.warningMessage : ''} ${className || ''}`}
    >
      {message}
    </span>
  );
};
